module.exports = __webpack_public_path__ + "static/mu-logo-ab6b283ac775de464931352d5b6febb2.svg";